var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{staticClass:"friend-item-container"},[_c('el-col',{attrs:{"span":6}},[_c('avatar',{attrs:{"src":_vm.friend.profile.avatar}})],1),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"friend-name"},[_vm._v(_vm._s(_vm.friend.profile.nick||_vm.friend.userID))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }